var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// api/currency-amount.ts
import { Float } from "@adornis/baseql/baseqlTypes.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { validate } from "@adornis/validation/decorators.js";
import { nonOptional } from "@adornis/validation/functions/nonOptional.js";
var CurrencyAmount = class extends AdornisEntity {
  constructor(doc) {
    super(doc);
  }
  // TODO use dinero.js here because this shouldnt be the same for all currencies
  get readableString() {
    return `${this.betrag.toFixed(2)} ${this.currency}`;
  }
  static sum(...amounts) {
    const first = amounts[0];
    if (!first)
      throw new Error("has to pass at least 1 amount to sum up");
    if (!amounts.every((amount) => amount.currency === first.currency))
      throw new Error("passed different currencies, cant add up yet");
    return new CurrencyAmount({
      betrag: amounts.reduce((sum, curr) => sum + curr.betrag, 0),
      currency: first.currency
    });
  }
  toString() {
    return this.readableString;
  }
};
CurrencyAmount._class = "CurrencyAmount";
__decorateClass([
  Field((type) => Float),
  validate(nonOptional({ allowFalsy: true }))
], CurrencyAmount.prototype, "betrag", 2);
__decorateClass([
  Field((type) => String, { default: (v) => v ?? "EUR" })
], CurrencyAmount.prototype, "currency", 2);
CurrencyAmount = __decorateClass([
  Entity()
], CurrencyAmount);
export {
  CurrencyAmount
};
